import React from "react";
import styles from "./OrderConsultation.module.scss";
import CalendarIcon from "../../../assets/img/calendar_green.png";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import UploadFiles from "../../Shared/UploadFiles/UploadFiles";
//import PhoneCode from 'react-phone-code';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
//import {CountrySelectWithIcon} from "react-phone-number-input/modules/CountrySelect";
import ConfirmConsultation from "./ConfirmConsultation/ConfirmConsultation";
import WRArrow from "../../../assets/img/whiteArrowR.png";
import PaymentMethod from "./PaymentMethod/PaymentMethod";
import FormHelperText from "@material-ui/core/FormHelperText";
import api from "../../../services/Api";
import User from "../../../services/User";
import validator from "validator/es";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import CheckboxIcon from "../../../assets/img/checkbox.png";
import CheckboxCheckedIcon from "../../../assets/img/checkboxChecked2.png";
import CompleteAccountCreation from "./CompleteAccountCreation/CompleteAccountCreation";
import ConfirmEmail from "./ConfirmEmail/ConfirmEmail";
import Fade from "@material-ui/core/Fade";
import LawyerCard from "../../Shared/LawyerCard/LawyerCard";
import { Link } from "react-router-dom";
import FreeOrderSuccess from "./FreeOrderSuccess/FreeOrderSuccess";
import {
  fetchCustomerService,
  fetchCustomerServices,
} from "../../../actions/customer";
//import ScrollIntoView from 'react-scroll-into-view';
import { connect } from "react-redux";

const errorText = "To pole jest wymagane";
const days = [
  "niedziela",
  "poniedziałek",
  "wtorek",
  "środa",
  "czwartek",
  "piątek",
  "sobota",
];
const months = [
  "styczeń",
  "luty",
  "marzec",
  "kwiecień",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpień",
  "wrzesień",
  "październik",
  "listopad",
  "grudzień",
];

class OrderConsultation extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      surname: null,
      email: null,
      phone: null,
      phoneCode: "+48",
      topic: null,
      comments: null,
      step: 1,
      checkbox: false,
      checkbox2: false,
      checkbox3: false,
      code: null,
      clientCode: null,
      errors: false,
      emailError: false,
      phoneError: false,
      nameError: false,
      surnameError: false,
      topicError: false,
      files: [],
      onFocus: false,
      touched: false,
      acceptanceError: null,
      acceptanceError2: null,
      acceptanceError3: null,
      userId: null,
      clientId: null,
      createAppointmentRef: null,
      uploadInProgress: false,
      buttonText: props.isFree ? "Zamów konsultację" : "Następny krok",
    };
  }

  componentDidMount() {
    let user;
    User.getUser() ? (user = User.getUser()) : (user = null);

    if (user) {
      api.get("users/" + user.id).then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({
            userId: response.data.data.id,
            email: response.data.data.email,
            phone: response.data.data.mobile,
            clientId: response.data.data.clientId,
          });
        }
      });
    }
  }

  changeField = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      touched: true,
      [event.target.name + "Error"]: false,
    });

    if (event.target.name === "checkbox") {
      this.setState({
        checkbox: !this.state.checkbox,
        acceptanceError: event.target.value ? null : "To pole jest wymagane",
      });
    } else if (event.target.name === "checkbox2") {
      this.setState({
        checkbox2: !this.state.checkbox2,
        acceptanceError2: event.target.value ? null : "To pole jest wymagane",
      });
    } else if (event.target.name === "checkbox3") {
      this.setState({
        checkbox3: !this.state.checkbox3,
        acceptanceError3: event.target.value ? null : "To pole jest wymagane",
      });
    } else if (event.target.name === "phone" && this.state.confirmedPhone) {
      this.setState({
        confirmedPhone: false,
      });
    }
  };

  Validate = (event) => {
    if (event.target.name === "email") {
      this.setState({
        emailError: event.target.value
          ? validator.isEmail(event.target.value)
            ? null
            : "Niepoprawny adres e-mail"
          : "Wprowadź adres e-mail!",
      });
    }

    if (event.target.name === "phone") {
      this.setState({
        phoneError: event.target.value
          ? validator.isMobilePhone(event.target.value, "pl-PL")
            ? null
            : "Niepoprawny numer telefonu!"
          : "Wprowadź numer telefonu!",
      });
    }

    if (event.target.name === "name") {
      this.setState({
        nameError: event.target.value ? null : "Wprowadź imię",
      });
    }

    if (event.target.name === "surname") {
      this.setState({
        surnameError: event.target.value ? null : "Wprowadź nazwisko",
      });
    }

    if (event.target.name === "topic") {
      this.setState({
        topicError: event.target.value ? null : "Wprowadź temat",
      });
    }
  };

  // changeCheckbox = () => {
  //     this.setState({
  //         checkbox: !this.state.checkbox
  //     })
  //
  //     if(!this.state.checkbox)
  // }

  changeStep = (directin, confirmedPhone, emailAlreadyUsed) => {
    // if (this.props.scrollToTop)
    //     this.props.scrollToTop();
    //document.getElementsByClassName('Mui-error')[0].scrollIntoView({behavior: "smooth",block: "center"});

    if (
      (this.props.isFree && this.props.serviceId) ||
      this.props.isSubscription
    ) {
      this.createAppointment();
      return;
    }

    if (confirmedPhone) {
      this.setState({
        confirmedPhone: true,
        emailError: emailAlreadyUsed
          ? "Podany adres e-mail jest już zajęty!"
          : false,
      });
    }

    if (directin === "next") {
      if (this.state.step === 1) {
        if (
          !this.state.touched ||
          this.state.nameError ||
          this.state.surnameError ||
          this.state.emailError ||
          this.state.phoneError ||
          this.state.topicError ||
          !this.state.checkbox ||
          !this.state.checkbox2 ||
          !this.state.checkbox3
        ) {
          let firstErr = document.getElementsByClassName("Mui-error")[0];
          if (firstErr) {
            firstErr.scrollIntoView({ block: "end", behavior: "smooth" });
          }

          return;
        }

        if (this.state.confirmedPhone) {
          this.props.setBoxContent(3.1, "Przypisz hasło");
          this.setState({
            step: 3.1,
          });
        }
        if (this.state.clientId) {
          this.props.setBoxContent(this.state.step + 1, "Płatność");
          this.setState({
            step: this.state.step + 2,
          });
        } else {
          this.props.setBoxContent(this.state.step + 1, "Potwierdzenie");
          this.setState({
            step: this.state.step + 1,
          });
        }
      } else if (this.state.step === 2) {
        this.props.setBoxContent(this.state.step + 1, "Płatność");
        this.setState({
          step: this.state.step + 1,
        });
      } else if (this.state.step === 3) {
        this.props.setBoxContent(3.1, "Przypisz hasło");
        this.setState({
          step: 3.1,
        });
      } else if (this.state.step === 3.1) {
        this.props.setBoxContent(3.2, "Potwierdź adres e-mail");
        this.setState({
          step: 3.2,
        });
      } else if (this.state.step === 4) {
        this.props.fetchCustomerService(this.state.clientId);
        this.props.setCustomerServiceId(this.state.clientId);
      }
    } else {
      if (this.state.step === 3.1) {
        this.props.setBoxContent(1);
        this.setState({
          step: 1,
        });

        return;
      }

      this.props.setBoxContent(this.state.step - 1);
      this.setState({
        step: Math.floor(this.state.step) - 1,
      });
    }
  };

  manageFileList = (mode, id) => {
    if (mode === "up InProgress") {
      this.setState({
        uploadInProgress: true,
      });
    } else if (mode == "add") {
      this.setState((state) => {
        const files = state.files.concat(id);
        const uploadInProgress = false;

        return {
          files,
          uploadInProgress,
        };
      });
    } else if (mode == "remove") {
      if (this.state.files.find((file) => file == id)) {
        this.setState((state) => {
          const files = state.files.filter((i) => i !== id);

          return {
            files,
          };
        });
      }
    }
  };

  setUserId = (userId) => {
    this.setState({
      userId: userId,
    });
  };

  setClinetId = (clientId) => {
    this.setState({
      clientId: clientId,
    });
  };

  paymentMethodRef = (paymentMethod) => {
    if (paymentMethod)
      this.setState({
        createAppointmentRef: paymentMethod.createAppointment,
      });
  };

  createAppointment = () => {
    if (User.getUser()) {
      api
        .post("/appointments", {
          start: this.props.time.start,
          end: this.props.time.end,
          topic: this.state.topic,
          comments: this.state.comments,
          lawyerId: this.props.lawyer.id,
          clientId: this.state.clientId,
          domainId: this.props.domain,
          file: this.state.files,
          isFree: true,
          status: "completed",
          registerId: this.props.serviceId,
        })
        .then((response) => {
          if (response.data.success === true) {
            this.props.refetchService();
            this.setState({
              step: 4,
            });
          }
        })
        .catch((error) => {
          alert("błąd");
          this.setState({
            error: error.response.data.error,
          });
        });
    }
  };

  render() {
    const {
      step,
      name,
      surname,
      email,
      phone,
      topic,
      comments,
      checkbox,
      checkbox2,
      checkbox3,
      emailError,
      phoneError,
      userId,
      files,
      topicError,
      nameError,
      surnameError,
      touched,
      acceptanceError,
      acceptanceError2,
      acceptanceError3,
      clientId,
    } = this.state;
    const { lawyer, time, price, isFree, serviceId, domain } = this.props;

    return (
      <Fade in={true} timeout={800}>
        <div className={styles.OrderConsultation}>
          {step == 1 && (
            <div>
              <div className={styles.ModalContent}>
                <div className={styles.lawyerCard}>
                  <LawyerCard lawyer={lawyer} imageUrl={this.props.imageUrl} />
                </div>
                <div className={styles.info}>
                  <img src={CalendarIcon} alt="calendar" />
                  <div>
                    Data i godzina: {days[time.start.getDay()]},{" "}
                    {time.start.getDate()} {months[time.start.getMonth()]},{" "}
                    {time.start.getHours()}:
                    {time.start.getMinutes() < 10
                      ? "0" + time.start.getMinutes()
                      : time.start.getMinutes()}
                    <br />
                  </div>
                </div>
                <form autoComplete="off">
                  <div className={styles.grayBg}>
                    {!this.state.userId && (
                      <div>
                        <FormControl
                          variant="outlined"
                          className={styles.singleField}
                        >
                          <label>
                            Imię <span className={styles.reqStar}>*</span>
                          </label>
                          <TextField
                            error={nameError}
                            helperText={nameError}
                            variant="outlined"
                            size="small"
                            type="text"
                            className={styles.input_cont}
                            InputProps={{
                              className: styles.input,
                            }}
                            name="name"
                            onChange={this.changeField}
                            value={name}
                            tabIndex="1"
                            data-index="1"
                            onBlur={this.Validate}
                          />
                        </FormControl>

                        <FormControl
                          variant="outlined"
                          className={styles.singleField}
                        >
                          <label>
                            Nazwisko <span className={styles.reqStar}>*</span>
                          </label>
                          <TextField
                            error={surnameError}
                            helperText={surnameError}
                            variant="outlined"
                            size="small"
                            type="text"
                            className={styles.input_cont}
                            InputProps={{
                              className: styles.input,
                            }}
                            name="surname"
                            onChange={this.changeField}
                            value={surname}
                            tabIndex="2"
                            data-index="2"
                            onBlur={this.Validate}
                          />
                        </FormControl>

                        <hr />

                        <FormControl
                          variant="outlined"
                          className={styles.singleField}
                        >
                          <label>
                            E-mail <span className={styles.reqStar}>*</span>
                          </label>
                          <TextField
                            error={emailError}
                            helperText={emailError}
                            variant="outlined"
                            size="small"
                            type="text"
                            className={styles.input_cont}
                            InputProps={{
                              className: styles.input,
                            }}
                            name="email"
                            onChange={this.changeField}
                            value={email}
                            tabIndex="3"
                            data-index="3"
                            inputProps={{
                              autoComplete: "off",
                            }}
                            onBlur={this.Validate}
                          />
                          <div className={styles.text}>
                            Przed wizytą otrzymasz również powiadomienie o
                            wizycie na swoją skrzynkę mailową.
                          </div>
                        </FormControl>

                        <FormControl
                          variant="outlined"
                          className={styles.singleField}
                        >
                          <label>
                            Telefon komórkowy{" "}
                            <span className={styles.reqStar}>*</span>
                          </label>
                          <div className={styles.phone}>
                            <Select
                              value={this.state.phoneCode}
                              name="phoneCode"
                              onChange={this.changeField}
                              label="Phone code"
                              className={styles.select}
                              //renderValue={()=> {return 1}}
                              IconComponent={() => (
                                <KeyboardArrowDownRoundedIcon color="primary" />
                              )}
                            >
                              <MenuItem value="+48">+48</MenuItem>
                            </Select>

                            <TextField
                              error={phoneError}
                              helperText={phoneError}
                              variant="outlined"
                              size="small"
                              type="text"
                              className={styles.input_cont}
                              InputProps={{
                                className: styles.input,
                              }}
                              name="phone"
                              onChange={this.changeField}
                              value={phone}
                              tabIndex="5"
                              data-index="5"
                              inputProps={{
                                autoComplete: "off",
                              }}
                              onBlur={this.Validate}
                            />
                          </div>
                          <div className={styles.text}>
                            Na ten numer otrzymasz kod do potwierdzenia wizyty
                            oraz przypomnienie o wizycie.
                          </div>
                        </FormControl>
                        <hr />
                      </div>
                    )}
                    <FormControl
                      variant="outlined"
                      className={styles.singleField}
                    >
                      <label>
                        <span>
                          Temat konsultacji{" "}
                          <span className={styles.reqStar}>*</span>
                        </span>
                        <span className={styles.showLength}>
                          {topic ? topic.length : 0}/250
                        </span>
                      </label>

                      <TextField
                        error={topicError}
                        helperText={topicError}
                        inputProps={{ maxLength: 250 }}
                        variant="outlined"
                        size="small"
                        type="text"
                        onChange={this.changeField}
                        value={topic}
                        placeholder="Wpisz temat konsultacji."
                        variant="outlined"
                        name="topic"
                        tabIndex="6"
                        data-index="6"
                        onBlur={this.Validate}
                      />
                    </FormControl>
                    <FormControl
                      variant="outlined"
                      className={styles.singleField}
                    >
                      <label>
                        <span>Dodatkowe uwagi</span>
                        <span className={styles.showLength}>
                          {comments ? comments.length : 0}/2500
                        </span>
                      </label>
                      {/*<TextField*/}
                      {/*    multiline*/}
                      {/*    rows={4}*/}
                      {/*    onChange={this.changeField}*/}
                      {/*    value={comments}*/}
                      {/*    placeholder="Możesz wpisać informacje, które chcesz przekazać przed wizytą"*/}
                      {/*    variant="outlined"*/}
                      {/*    name="comments"*/}
                      {/*    tabIndex="7"*/}
                      {/*    data-index="7"*/}
                      {/*/>*/}
                      <textarea
                        onChange={this.changeField}
                        value={comments}
                        placeholder="Możesz wpisać informacje, które chcesz przekazać przed wizytą"
                        name="comments"
                        tabIndex="7"
                        maxLength={2500}
                        data-index="7"
                      />
                    </FormControl>
                    <div>
                      <UploadFiles manageFileList={this.manageFileList} />
                    </div>
                  </div>
                  <div>
                    <div className={styles.acceptance}>
                      <FormControlLabel
                        className={styles.label}
                        control={
                          <Checkbox
                            inputProps={{ "aria-label": "Acceptance" }}
                            color="primary"
                            checked={checkbox}
                            name="checkbox"
                            onChange={this.changeField}
                            icon={<img src={CheckboxIcon} alt="checkbox" />}
                            checkedIcon={
                              <img src={CheckboxCheckedIcon} alt="checkbox" />
                            }
                          />
                        }
                        label={
                          <>
                            <span className={styles.reqStar}>*</span> Akceptuję{" "}
                            <Link to="/klient-regulamin" target="_blank">
                              regulamin
                            </Link>{" "}
                            serwisu Wideoprawnik.pl oraz{" "}
                            <Link to="/polityka-prywatnosci" target="_blank">
                              politykę prywatności
                            </Link>
                            {!checkbox && touched && acceptanceError && (
                              <FormHelperText error>
                                To pole jest wymagane
                              </FormHelperText>
                            )}
                          </>
                        }
                      />
                    </div>
                    <div className={styles.acceptance}>
                      <FormControlLabel
                        className={styles.label}
                        control={
                          <Checkbox
                            inputProps={{ "aria-label": "Acceptance" }}
                            color="primary"
                            checked={checkbox2}
                            name="checkbox2"
                            onChange={this.changeField}
                            icon={<img src={CheckboxIcon} alt="checkbox" />}
                            checkedIcon={
                              <img src={CheckboxCheckedIcon} alt="checkbox" />
                            }
                          />
                        }
                        label={
                          <>
                            <span className={styles.reqStar}>*</span> Wyrażam
                            zgodę na komunikację o usługach i funkcjonalnościach
                            Wideoprawnik.pl
                            {!checkbox2 && touched && acceptanceError2 && (
                              <FormHelperText error>
                                To pole jest wymagane
                              </FormHelperText>
                            )}
                          </>
                        }
                      />
                    </div>
                    <div className={styles.acceptance}>
                      <FormControlLabel
                        className={styles.label}
                        control={
                          <Checkbox
                            inputProps={{ "aria-label": "Acceptance" }}
                            color="primary"
                            checked={checkbox3}
                            name="checkbox3"
                            onChange={this.changeField}
                            icon={<img src={CheckboxIcon} alt="checkbox" />}
                            checkedIcon={
                              <img src={CheckboxCheckedIcon} alt="checkbox" />
                            }
                          />
                        }
                        label={
                          <>
                            <span className={styles.reqStar}>*</span> Wyrażam
                            zgodę na komunikację marketingową serwisu
                            Wideoprawnik.pl oraz jego partnerów.
                            {!checkbox3 && touched && acceptanceError3 && (
                              <FormHelperText error>
                                To pole jest wymagane
                              </FormHelperText>
                            )}
                          </>
                        }
                      />
                    </div>
                    <hr style={{ margin: "40px 0" }} />
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        className={styles.button}
                        onClick={() => this.changeStep("next")}
                        disabled={
                          !this.state.touched ||
                          !checkbox ||
                          !checkbox2 ||
                          !checkbox3 ||
                          ((!email || !name || !surname || !phone) &&
                            !userId) ||
                          !topic ||
                          emailError ||
                          phoneError ||
                          this.state.uploadInProgress
                        }
                      >
                        {this.state.buttonText}{" "}
                        {!this.props.isFree && (
                          <img src={WRArrow} alt="right arrow" />
                        )}
                      </Button>
                    </div>
                    <div className={styles.reqInfo}>* Pola wymagane</div>
                  </div>
                </form>
              </div>
            </div>
          )}
          {step == 2 && (
            <ConfirmConsultation
              changeStep={this.changeStep}
              phone={phone}
              resend={this.sendSMS}
            />
          )}

          {/*
                    Nie było czasu żeby całość przerabiać dlatego tak dziwnie zrobione.
                    Montuje PaymentMethod w 3 przypadkach (w 2 jako ukryte)
                    żeby w przypadku niezarejestrowanego klienta móc uruchomić metody createAppointment itd.
                    dopiero w ostatnim kroku
                */}
          {(step == 3 || step == 3.1 || step == 3.2) && (
            <PaymentMethod
              name={name}
              surname={surname}
              userId={userId}
              clientId={clientId}
              email={email}
              phone={phone}
              topic={topic}
              comments={comments}
              files={files}
              price={price}
              time={time}
              lawyerId={lawyer.id}
              domain={this.props.domain}
              changeStep={this.changeStep}
              setClinetId={this.setClinetId}
              ref={this.paymentMethodRef}
              show={step == 3}
            />
          )}
          {step == 3.1 && (
            <CompleteAccountCreation
              changeStep={this.changeStep}
              setUserId={this.setUserId}
              phone={phone}
              email={email}
              clientId={this.state.clientId}
              createAppointmentRef={this.state.createAppointmentRef}
            />
          )}

          {step == 3.2 && (
            <ConfirmEmail
              changeStep={this.changeStep}
              email={email}
              userId={this.state.userId}
            />
          )}
          {step == 4 && <FreeOrderSuccess time={time} />}
        </div>
      </Fade>
    );
  }
}

OrderConsultation.defaultProps = {};

const mapDispatchToProps = {
  fetchCustomerServices,
  fetchCustomerService,
};

export default connect(null, mapDispatchToProps)(OrderConsultation);
